export const generativeAiBrandGuideline = "/generative_ai/brand_guideline";
